export const light = {
  palette: {
    primary: ['#0071E3', '#246CB4', '#4599ed', '#0062FF'],
    secondary: ['#B1BDCE', '#E9F2FA'],
    warning: ['#FF9500', '#EA6300', '#EA63001A', '#fceacf'],
    success: ['#24932B', '#90C894', '#4491871A', '#4ebd55'],
    error: ['#CC0505', '#ad3e3e', '#FF0000'],
    gray: ['#E8E8EB', '#E3E7ED', '#C4C4C4', '#E6E6E6', '#F7F8FA'],
    background: ['#0B2629', 'transparent', '#E6B471'],
    text: ['#000000', '#ffffff', '#717171', '#585858', '#E6B471'],
    shadow: ['#0071e329', '#DCDCDD', '#678272'],
    white: ['#FFFFFF'],
    active: ['#E6B471'],
    border: ['#E6B471', '#FAEDE5', '#fff'],
    lightGreen: ['#7AEAA7'],
  },
  sizes: {
    lineHeight: {
      xSmall: '10px',
      tiny: '19px',
      smaller: '30px',
      small: '45px',
      normal: '50px',
    },
    gutter: {
      horizontal: '30px',
      vertical: '20px',
      tiny: '8px',
      custom: '15px',
      smaller: '20px',
      small: '30px',
      normal: '40px',
      medium: '60px',
      big: '80px',
      large: '100px',
      larger: '140px',
    },
    border: {
      tiny: '5px',
      small: '7px',
      normal: '18px',
    },
    gap: {
      tiny: '5px',
      small: '10px',
      normal: '25px',
      medium: '20px',
      big: '40px',
    },
    borderRadius: {
      normal: '4px',
      tiny: '10px',
      smaller: '20px',
      small: '30px',
    },
    button: {
      normal: {
        width: '150px',
        height: '30px',
      },
    },
    inputBox: {
      height: {
        tiny: '40px',
        xsmaller: '47px',
        smaller: '50px',
        small: '58px',
        medium: '60px',
        large: '64px',
        larger: '80px',
      },
    },
    textArea: {
      height: {
        medium: '113px',
        large: '120px',
        larger: '160px',
      },
    },
    font: {
      error: '12px',
      normal: '14px',
      header1: '26px',
      header2: '24px',
      header3: '18px',
      big: '16px',
    },
    mdFont: {
      error: '12px',
      normal: '14px',
      header1: '26px',
      header2: '24px',
      header3: '22px',
      big: '16px',
    },
    lgFont: {
      error: '12px',
      normal: '14px',
      header1: '26px',
      header2: '24px',
      header3: '22px',
      big: '16px',
    },
    xlFont: {
      error: '12px',
      normal: '14px',
      header1: '22px',
      header2: '20px',
      header3: '18px',
      big: '16px',
    },
    xlrFont: {
      error: '12px',
      normal: '14px',
      header1: '22px',
      header2: '20px',
      header3: '18px',
      big: '16px',
    },
    xxlFont: {
      error: '14px',
      normal: '16px',
      big: '16px',
      header1: '26px',
      header2: '24px',
      header3: '22px',
    },
    vxxlFont: {
      error: '16px',
      normal: '16px',
      big: '16px',
      header1: '29px',
      header2: '24px',
      header3: '22px',
    },
  },
  fonts: {
    primary: 'Space Grotesk Regular',
    pre: 'Consolas, Liberation Mono, Menlo, Courier, monospace',
  },
};

export const dark = {};

export const themes = { light, dark };

// new theme changes - background index 0 - #0B2629, text index 4 - #E6B471, active index 0 - #E6B471, border index 0 - #E6B471, border index 1 - #FAEDE5, background index 2 - #E6B471
